import { render, staticRenderFns } from "./ContractCard.vue?vue&type=template&id=07097d9d&scoped=true&"
import script from "./ContractCard.vue?vue&type=script&lang=js&"
export * from "./ContractCard.vue?vue&type=script&lang=js&"
import style0 from "./ContractCard.vue?vue&type=style&index=0&id=07097d9d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07097d9d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07097d9d')) {
      api.createRecord('07097d9d', component.options)
    } else {
      api.reload('07097d9d', component.options)
    }
    module.hot.accept("./ContractCard.vue?vue&type=template&id=07097d9d&scoped=true&", function () {
      api.rerender('07097d9d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/fuel-resources/cards/ContractCard.vue"
export default component.exports